// GW事業者情報登録のラベル
export const LABELS = {
  TAB_TITLE_GW_LIST: "GW一覧",
  TAB_TITLE_ACCOUNT: "アカウント",
  TAB_TITLE: "GW契約一覧",
  TITLE_OTHER: "その他情報",
  COMPANY_CODE: "事業者コード",

  CORP_TABLE_CORPNAME: "GW名",
  CORP_TABLE_SERVICE: "契約サービス",
  CORP_TABLE_STATUS: "契約ステータス",
  CORP_TABLE_CONNECTION_ENVIRONMENTAL: "接続環境",
  CORP_TABLE_IMPLEMENTATION_CONFIRMATION: "実装確認",
  CORP_TABLE_IPID_PRIOR_PAYOUT: "IPID事前払出",

  CORP_GW_TITLE: "　GW追加　",
  CORP_GW_CODE: "GWコード",
  CORP_GW_NAME: "GW名",
  CORP_GW_SERVICE: "契約サービス",
  CORP_GW_STATUS: "契約ステータス",

  CONTRACT_STATUS_STOPPED: "停止中",
  CONTRACT_STATUS_NOT_STOPPED: "契約中",

  APPROVAL_STATUS_BEFOREAPPROVAL: "未申請",
  SETTING_UNSET: "未設定",
  SETTING_CONFIGURED: "設定済",
} as const;
